var components = {};

components.myAccount = require('./myAccount');
components.loginPage = require('./loginPage');
components.teaserContent = require('./teaserContent');
components.footer = require('./footer');
components.loginModal = require('./loginModal');
components.breadcrumb = require('./breadcrumb');
components.breadcrumbPublisher = require('./breadcrumbPublisher');
components.searchBox = require('./searchBox');
components.topNav = require("./topNav");
components.header = require("./header");

module.exports = components;


// WEBPACK FOOTER //
// ./src/scripts/components/index.js